// extracted by mini-css-extract-plugin
export default {"icon":"iconactive_icon__t6LUM","action":"iconactive_action__ZybVY"};